import React from 'react';

import { mdiArrowUp } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

import { SHORTCUTS } from '../../keys';
import { KeyboardKey } from '../KeyboardKey';

/** Display the "Up" arrow key with an accessible label. */
export const KeyUpArrow = () => {
    const { translateKey } = useTranslate();
    return <KeyboardKey label={translateKey(SHORTCUTS.UP_ARROW_LABEL)} icon={mdiArrowUp} />;
};
